import { render, staticRenderFns } from "./AppForbidden.vue?vue&type=template&id=8a47d666&scoped=true&"
import script from "./AppForbidden.vue?vue&type=script&lang=ts&"
export * from "./AppForbidden.vue?vue&type=script&lang=ts&"
import style0 from "./AppForbidden.vue?vue&type=style&index=0&id=8a47d666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a47d666",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VContainer})
